import { requestGooseAPI, getAPIPath } from '../shared/request'
import {
  ADMIN_CANCEL_INVOICE_PATH,
  ADMIN_INVOICE_ID_PATH,
  ADMIN_LOCATION_INVOICES_ID_PATH,
  ADMIN_LOCATION_INVOICES_PATH,
} from '../types/constants'
import {
  OrderAdminDto,
  InvoiceAdminDto,
  InvoiceUpdateInput,
  APIInvoiceAdminDtoResponse,
  TInvoiceListOptions,
  CustomInvoiceAdminDto,
} from '../types'

export const AdminInvoiceService = {
  cancelInvoice: (
    locationId: string,
    orderId: string,
    invoiceId: string,
    amount?: number | null
  ): Promise<OrderAdminDto> => {
    const payload = amount === undefined ? {} : { data: { amount } }
    return requestGooseAPI<OrderAdminDto>({
      url: getAPIPath(ADMIN_CANCEL_INVOICE_PATH, { locationId, orderId, invoiceId }),
      method: 'PUT',
      ...payload,
    })
  },

  get: (locationId: string, invoiceId: string): Promise<CustomInvoiceAdminDto> => {
    return requestGooseAPI<CustomInvoiceAdminDto>({
      url: getAPIPath(ADMIN_LOCATION_INVOICES_ID_PATH, { locationId, invoiceId }),
      method: 'GET',
      params: {
        includes: [
          'activities.unitActivityRelations.resourceUnit',
          'activities.petActivityRelations',
          'instructions.tags.tag',
          'notes',
          'location',
          'items.locationServiceType.serviceType',
          'items.petRelations.invoicePet.pet',
          'items.petRelations.invoicePet.data',
          'period',
          'order.payments.transactions',
          'order.pets.locationPetProfile.tags',
          'order.pets.locationPetProfile.breed',
          'order.pets.locationPetProfile.profileImage',
          'order.pets.locationSpecies.species',
          'order.locationUserProfile.associatedContacts',
          'order.primaryServiceType.serviceType',
          'order.userData',
        ],
      },
    })
  },

  getList: (locationId: string, options: TInvoiceListOptions): Promise<APIInvoiceAdminDtoResponse> => {
    return requestGooseAPI<APIInvoiceAdminDtoResponse>({
      url: getAPIPath(ADMIN_LOCATION_INVOICES_PATH, { locationId }),
      method: 'GET',
      params: {
        ...options,
        includes: [
          'activities.unitActivityRelations.resourceUnit',
          'location',
          'period',
          'order.pets.locationPetProfile.breed',
          'order.pets.locationPetProfile.profileImage',
          'order.pets.locationSpecies.species',
          'order.invoices.items.locationServiceType',
          'order.payments.transactions',
          'order.locationUserProfile.associatedContacts',
          'order.locationUserProfile.tagRelations.tag',
          'order.primaryServiceType.serviceType',
          'activities.petActivityRelations',
          'items.locationServiceType.serviceType',
          'items.petRelations',
        ],
      },
    })
  },

  updateInvoice: (
    locationId: string,
    orderId: string,
    invoiceId: string,
    data: InvoiceUpdateInput
  ): Promise<InvoiceAdminDto> => {
    return requestGooseAPI<InvoiceAdminDto>({
      url: getAPIPath(ADMIN_INVOICE_ID_PATH, { locationId, orderId, invoiceId }),
      method: 'PUT',
      data,
    })
  },
}
